import { config } from '~/constants/config';

export const getDomElements = (regexTagName = '') => {
  const $billy = document.querySelector(`.${config.BILLY_CLASSNAME}`);
  return Array.from(document.querySelectorAll('body, body *')).filter(element => { 
    let tagName = element.tagName.toUpperCase()
    if ($billy) {
      if (!$billy.contains(element) && tagName.match(regexTagName)) {
        return element;
      }
    } else if (tagName.match(regexTagName)) {
      return element;
    }
  });
};

export const getElementsAndStyles = ({regexTagName, stylePropery}) => {
  const initialDom = [];
  const elements = getDomElements(regexTagName);
  for (let element of elements){
    const item = { $element: element };
    item[stylePropery] = element.style[stylePropery];
    initialDom.push(item)
  }
  return initialDom;
};


// WEBPACK FOOTER //
// ./src/services/domService.js